import React, { useEffect } from 'react'
import Swal from 'sweetalert2'
import axios from 'axios'
import useForm from '../../hooks/useForm'

const EditHiringModal = ({ isOpen, onClose, onSuccess, hiring }) => {
    const API_URL = process.env.REACT_APP_API_URL;
    const validate = (values) => {
        const errors = {};
        if (!values.position) errors.position = "Please enter position";
        if (!values.branch) errors.branch = "Please enter branch";
        if (!values.description) errors.description = "Please enter description";
        if (!values.responsibilities) errors.responsibilities = "Please enter responsibilities";
        if (!values.qualifications) errors.qualifications = "Please enter qualifications";
        if (!values.hiring_status) errors.hiring_status = "Select hiring status";
        return errors;
    };

    // Initialize form using useForm
    const { values, errors, isSubmitting, handleChange, handleSubmit, setValues } = useForm({
        position: '',
        branch: '',
        description: '',
        responsibilities: '',
        qualifications: '',
        hiring_status: '' 
    }, validate); 

    useEffect(() => {
        if (hiring) {
            const { position, branch, description, responsibilities, qualifications, hiring_status } = hiring;
            setValues({ position, branch, description, responsibilities, qualifications, hiring_status });
        }
    }, [hiring, setValues]);

    const onSubmit = async (formValues) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.put(
                `${API_URL}/hirings/${hiring.id}`,
                formValues,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            onSuccess();
            onClose();

            Swal.fire({
                title: 'Success!',
                text: response.data.message,
                icon: 'success',
                showConfirmButton: false,
                timer: 3000
            });
        } catch (error) {
            console.error('Error updating employee:', error);
            Swal.fire({
                title: 'Error!',
                text: 'There was an error updating the employee.',
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            });
        }
    };
    return (
        <>
            <div id="static-modal" className={`fixed inset-0 z-50 flex overflow-y-auto items-center justify-center bg-black bg-opacity-50 ${isOpen ? 'flex' : 'hidden'}`} data-modal-backdrop="static" tabIndex="-1" aria-hidden="true">
                <div className="relative p-4 w-full max-w-2xl max-h-full">
                    <div className="relative bg-white rounded-lg shadow">
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
                            <h3 className="text-xl font-semibold text-gray-900">
                                Edit Hiring Modal
                            </h3>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                onClick={onClose}
                            >
                                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="p-4 md:p-5 space-y-4 ">
                            <form onSubmit={(e) => handleSubmit(e, onSubmit)}>
                                <div className='flex flex-row gap-5 w-full'>
                                    <div className="mb-4 w-full">
                                        <label htmlFor="position" className="block text-sm font-medium text-gray-700">Position</label>
                                        <input 
                                            type="text" 
                                            id="position" 
                                            name="position" 
                                            value={values.position} 
                                            onChange={handleChange} 
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5" 
                                        />
                                        {errors.position && <p className="text-red-500 text-sm">{errors.position}</p>}
                                    </div>
                                    <div className="mb-4 w-full">
                                        <label htmlFor="branch" className="block text-sm font-medium text-gray-700">Branch</label>
                                        <input 
                                            type="text" 
                                            id="branch" 
                                            name="branch" 
                                            value={values.branch} 
                                            onChange={handleChange} 
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5" 
                                        />
                                        {errors.branch && <p className="text-red-500 text-sm">{errors.branch}</p>}
                                    </div>  
                                </div>  
                                <div className="mb-4 w-full">
                                    <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description</label>
                                    <input 
                                        type="text" 
                                        id="description" 
                                        name="description" 
                                        value={values.description} 
                                        onChange={handleChange} 
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5" 
                                    />
                                    {errors.description && <p className="text-red-500 text-sm">{errors.description}</p>}
                                </div>
                                <div className="w-full">
                                    <label htmlFor="responsibilities" className="block py-2 font-medium text-gray-700">Responsibilities</label>
                                    <textarea
                                        id="responsibilities"
                                        name="responsibilities"
                                        value={values.responsibilities}
                                        onChange={handleChange}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                                        rows="3"
                                        placeholder='Use [Enter space] for separation in the next line.'
                                    ></textarea>
                                    {errors.responsibilities && <p className="text-red-500 text-sm">{errors.responsibilities}</p>}
                                </div>  
                                <div className="w-full">
                                    <label htmlFor="qualifications" className="block py-2 font-medium text-gray-700">Qualifications</label>
                                    <textarea
                                        id="qualifications"
                                        name="qualifications"
                                        value={values.qualifications}
                                        onChange={handleChange}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                                        rows="3"
                                        placeholder='Use [Enter space] for separation in the next line.'
                                    ></textarea>
                                    {errors.qualifications && <p className="text-red-500 text-sm">{errors.qualifications}</p>}
                                </div>  
                                
                                <div className="w-full mb-4">
                                    <label htmlFor="hiring_status" className="block font-medium text-gray-700">Status</label>
                                    <select
                                        id="hiring_status"
                                        name="hiring_status"
                                        value={values.hiring_status}
                                        onChange={handleChange}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                                    >
                                        <option value="">Select a Status</option>
                                        <option value="0">On-going</option>
                                        <option value="1">Completed</option>
                                    </select>
                                    {errors.hiring_status && <p className="text-red-500 text-sm">{errors.hiring_status}</p>}
                                </div>

                                <div className="flex items-center p-2 md:p-2 border-t border-gray-200 rounded-b">
                                    <button 
                                        type="submit" 
                                        className="text-white bg-[var(--customRed)] hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Updating' : 'Update'}
                                    </button>
                                    <button type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-red-700 focus:z-10 focus:ring-4 focus:ring-gray-100" onClick={onClose}>Close</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditHiringModal;
